import { Inline, Stack, Text } from '@etg/wings';
import { price as priceUtil } from '@eti/utils';
import { Accordion, ScreenReaderPrice } from '@eti/components';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';

const inlineStyles = css`
  justify-content: space-between;
`;

const contentStyles = css`
  ${inlineStyles};
  padding-inline-start: 8px;
`;

export type CarrierPriceType = {
  carrierName: string;
  providerPrice?: number;
  vat?: number;
};

interface CarrierPriceListProps {
  amountType: 'providerPrice' | 'vat';
  carrierPrices: CarrierPriceType[];
  dataTestId: string;
  heading: string;
  price: number;
}

const CarrierPriceList = ({
  dataTestId,
  heading,
  carrierPrices = [],
  amountType,
  price,
}: CarrierPriceListProps) => {
  const { t } = useTranslation();

  return (
    <Accordion id={`${dataTestId}-accordion`}>
      <Inline alignY="center" className={inlineStyles}>
        <Accordion.Header data-testid={`heading-expansion-panel-${amountType}`}>
          <Text>{heading}</Text>
        </Accordion.Header>
        <Text aria-hidden data-testid={`total-${amountType}-price`}>
          {priceUtil.formatPrice(price)}
        </Text>
        <ScreenReaderPrice price={priceUtil.formatPrice(price)} />
      </Inline>
      <Accordion.Body data-testid="expansion-content">
        <Stack role="list" spacing={0}>
          {carrierPrices.map((carrierPrice, index) => (
            <Inline
              className={contentStyles}
              key={`${carrierPrice.carrierName}-${index}`}
              role="listitem"
            >
              <Text data-testid={`carrier-${carrierPrice.carrierName}-name`}>
                {amountType === 'vat'
                  ? t('Cart.TaxesAndAirlineFees.WithCarriers', carrierPrice.carrierName)
                  : carrierPrice.carrierName}
              </Text>
              <Text aria-hidden data-testid={`carrier-${carrierPrice.carrierName}-price`}>
                {priceUtil.formatPrice(carrierPrice[amountType])}
              </Text>
              <ScreenReaderPrice price={priceUtil.formatPrice(carrierPrice[amountType])} />
            </Inline>
          ))}
        </Stack>
      </Accordion.Body>
    </Accordion>
  );
};

export default CarrierPriceList;
